import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataField } from '../../shared/datafields/models/datafield';
import { DataFieldValue } from '../../shared/datafields/models/datafield-value';
import { JsonHttpService } from '../../shared/http/json-http.service';

@Injectable({
    providedIn: 'root'
})
export class PartnerConfigurationKeyService {

    constructor(private httpService: JsonHttpService) { }

    getConfigurationKeys(partnerId: number, keyUsageName: string, dynamicForeignKey?: number): Promise<DataField[]> {
        const options = {
            params: new HttpParams()
                .set('partnerId', `${partnerId}`)
                .set('keyUsageName', `${keyUsageName}`)
        };
        if (dynamicForeignKey) {
            options.params = options.params.set('dynamicForeignKey', `${dynamicForeignKey}`);
        }
        return this.httpService.get('/api/partners/configuration-keys/get-by-partner', options).toPromise();
    }

    saveConfigurationKeys(partnerId: number, datafieldValues: DataFieldValue[]): Promise<void> {
        const options = { params: new HttpParams().set('partnerId', `${partnerId}`) };
        return this.httpService.post('/api/partners/configuration-keys/save-by-partner', datafieldValues, options).toPromise();
    }
}
